import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("rosters")
export class Roster extends BaseEntity {
  public name: string;
  public startDate: Date;
  public endDate: Date;
  public length: number;
  public generateDaysAhead: number;
}
